export type SkuTableMessages = {
  deleteSkuDialogTitle: string;
  deleteSkuDialogContent: string;
  deleteSkuDialogCancel: string;
  deleteSkuDialogConfirm: string;
  deleteSkuSuccess: string;

  skuCreateSuccess: string;
  skuUpdateSuccess: string;

  titleCardSku: string;
  titleSku: string;

  skuUpdateError: string;

  //COLUMS
  imageColumn: string;
  statusColumn: string;
  codeColumn: string;
  nameColumn: string;
  variationColumn: string;
  stockolumn: string;
  priceColumn: string;
  balanceColumn: string;
  optionsColumn: string;
};

export const SKU_TABLE_MESSAGES: SkuTableMessages = {
  titleCardSku: "Detalhes dos SKUs",
  titleSku: "SKUs",
  deleteSkuDialogTitle: "Excluir SKU",
  deleteSkuDialogContent: "Tem certeza de que deseja excluir este SKU?",
  deleteSkuDialogCancel: "Cancelar",
  deleteSkuDialogConfirm: "Confirmar",
  deleteSkuSuccess: "SKU excluído com sucesso!",

  skuCreateSuccess: "SKU Criado com sucesso!",
  skuUpdateSuccess: "SKU atualizado com sucesso!",

  skuUpdateError: "Erro ao salvar SKU!",

  imageColumn: "Imagem",
  statusColumn: "Ativo",
  codeColumn: "Código",
  nameColumn: "Nome do produto",
  variationColumn: "Variação",
  stockolumn: "Estoque",
  priceColumn: "Preço",
  balanceColumn: "Saldo",
  optionsColumn: "Opções",
};
